// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { DatabaseZap } from "lucide-react";
import { useTranslation } from "react-i18next";
import { CodeHighlight } from "@/components/shared/code-highlight";

interface TransformationSqlTabProps {
  sqlContent?: string;
}

export function TransformationSqlTab({ sqlContent }: TransformationSqlTabProps) {
  const { t } = useTranslation("back-office");

  if (!sqlContent) {
    return (
      <div className="flex flex-col items-center justify-center py-24 text-center">
        <DatabaseZap className="h-12 w-12 text-muted-foreground mb-4" />
        <p className="text-sm text-muted-foreground">{t("transformations.detail.fields.noSql")}</p>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="rounded-lg border">
        <CodeHighlight value={sqlContent} lang="sql" />
      </div>
    </div>
  );
}
